(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
// inicijalizacija Slick slidera sa boljim prikazom na mobilnim uređajima
document.addEventListener('DOMContentLoaded', function() {
  if (typeof jQuery !== 'undefined' && jQuery('.seasonal-slider').length) {
    jQuery('.seasonal-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.2,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-slider"] && !Shopify.designMode) return;
  try {
    
// inicijalizacija Slick slidera sa boljim prikazom na mobilnim uređajima
document.addEventListener('DOMContentLoaded', function() {
  if (typeof jQuery !== 'undefined' && jQuery('.seasonal-slider').length) {
    jQuery('.seasonal-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.2,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
